import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../../infrastructure/firebase/firebaseConfig';
import { BASELINE_USERS, BASELINE_ROOMS } from '../../infrastructure/firebase/StatsService';

interface Stats {
  users: number;
  rooms: number;
  loaded: boolean;
}

const INITIAL: Stats = { users: 0, rooms: 0, loaded: false };

export function useStats(): Stats {
  const [stats, setStats] = useState<Stats>(INITIAL);

  useEffect(() => {
    const r = ref(database, 'stats');
    const unsub = onValue(
      r,
      snap => {
        const v = snap.val() ?? {};
        setStats({
          users: BASELINE_USERS + (typeof v.totalUsers === 'number' ? v.totalUsers : 0),
          rooms: BASELINE_ROOMS + (typeof v.totalRooms === 'number' ? v.totalRooms : 0),
          loaded: true,
        });
      },
      () => {
        setStats({ users: BASELINE_USERS, rooms: BASELINE_ROOMS, loaded: true });
      }
    );
    return () => unsub();
  }, []);

  return stats;
}
